<script>
    import {VPagination} from 'vuetify/lib'
	export default {
		extends: VPagination,
		name: "AppBindezPagination",
		props: {
			circle: Boolean,
			disabled: Boolean,
			length: {
				type: Number,
				default: 0,
				validator: val => val % 1 === 0
			},
			totalVisible: [Number, String],
			nextSkipCount: {
				type: Number,
				default: 1
			},
			perPage: {
				type: Number,
				default: 10
			},
			nextIcon: {
				type: String,
				default: "$vuetify.icons.next"
			},
			prevIcon: {
				type: String,
				default: "$vuetify.icons.prev"
			},
			value: {
				type: Number,
				default: 0
			},
		},
		methods: {
			next(event) {
				event.preventDefault();
				event.stopPropagation();
				let nextPage = this.value;
                nextPage = (this.nextSkipCount < this.length) && (nextPage+this.nextSkipCount < this.length) ? nextPage+this.nextSkipCount : this.length;
                this.$emit("next");
                this.$emit("input", nextPage);
			},

            previous(event){
				event.preventDefault();
				event.stopPropagation();
                let prevPage = this.value;
				prevPage = (this.value - this.nextSkipCount <= 0) || (this.length < this.nextSkipCount) ? 1 : prevPage - this.nextSkipCount;
				this.$emit("prev");
				this.$emit("input", prevPage);
            }
		}
	}
</script>

<style scoped>

</style>
